// @flow
import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {useActions} from '../../../../../utils/globalStore';
import {actions} from '../duck';
import type {RootState} from '../../../../';
import type {PromotionRequest} from '../../../../../entities';

// Currency
const currencyCountry = (state: RootState) => state.currency.currency;

export function useGetCurrencyCountry() {
  return useSelector(currencyCountry);
}

// Available countries
const availableShippingCountriesConfigSelector = (state: RootState) =>
  state.logisticsConfig.shippingMethod?.availableShippingCountries;
const availableShippingCountriesSelector = (state: RootState) =>
  state.logisticsConfig.shippingMethod?.availableShippingCountries;

export function useGetAvailableShippingCountries() {
  const configAvailableShippingCountries = useSelector(
    availableShippingCountriesConfigSelector
  );

  const availableShippingCountries = useSelector(
    availableShippingCountriesSelector
  );

  if (availableShippingCountries) {
    return availableShippingCountries;
  }

  return configAvailableShippingCountries;
}

// Promotion
export function useResetState() {
  const resetStateAction = useActions(actions.resetState);

  const resetState = useCallback(() => {
    return resetStateAction();
  }, [resetStateAction]);

  return {resetState};
}

export function useFetchPromotions() {
  const promotionMethod = useSelector(
    (state: RootState) => state.logisticPromotionConfig.promotionMethod
  );
  const fetchPromotionsAction = useActions(actions.fetchPromotion);
  const fetchPromotions = useCallback(() => {
    fetchPromotionsAction();
  }, [fetchPromotionsAction]);

  return {promotionMethod, fetchPromotions};
}

export function useCRUDPromotion() {
  const isSaving = useSelector(
    (state: RootState) => state.logisticPromotionConfig.isSaving
  );
  const savingPromotionSuccess = useSelector(
    (state: RootState) => state.logisticPromotionConfig.savingPromotionSuccess
  );
  const savingPromotionError = useSelector(
    (state: RootState) => state.logisticPromotionConfig.savingPromotionError
  );
  const messageError = useSelector(
    (state: RootState) => state.logisticPromotionConfig.messageError
  );

  const editPromotions = useActions(actions.editPromotion);
  const savePromotions = useActions(actions.savePromotion);
  const deletePromotions = useActions(actions.deletePromotion);

  const updatePromotion = (promotion: PromotionRequest) => {
    editPromotions({promotionRequest: promotion});
  };

  const savePromotion = (promotion: PromotionRequest) => {
    savePromotions({promotionRequest: promotion});
  };

  const deletePromotion = (promotion: PromotionRequest) => {
    deletePromotions({promotionRequest: promotion});
  };

  return {
    isSaving,
    savingPromotionSuccess,
    savingPromotionError,
    messageError,
    updatePromotion,
    savePromotion,
    deletePromotion,
  };
}
